/**
 * iOS-style share icon (square.and.arrow.up)
 * Matches the standard iOS share sheet icon design.
 * Use className="text-primary" for app colors.
 */
interface ShareIconProps {
  className?: string;
}

export const ShareIcon = ({ className }: ShareIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Rounded square */}
    <rect x="4" y="10" width="16" height="10" rx="2" ry="2" />
    {/* Arrow from top center pointing up */}
    <path d="M12 10V4M12 4l-3 3M12 4l3 3" />
  </svg>
);
